import api from './api'

/**
 * Serviço de Upload de Arquivos
 */
export default {
  /**
   * Upload de arquivo
   */
  upload(file, metadata = {}) {
    const formData = new FormData()
    formData.append('file', file)
    
    // Adicionar metadata se houver
    Object.keys(metadata).forEach(key => {
      formData.append(key, metadata[key])
    })
    
    return api.post('/api/files/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
}
